const ExerciseTypeSearch = ({
    form,
    mode = 'add',
    filteredResults,
    showSuggestions,
    showInvalidMessage,
    handleChange,
    handleSelect,
    clearSearch,
    isLocked
}) => {
    const favoriteSessions = filteredResults.filter((result) => result.kind === 'favorite_session');
    const exerciseTypes = filteredResults.filter((result) => result.kind === 'exercise_type');
    const stepResults = filteredResults.filter((result) => result.kind === 'steps');

    return (
        <div className="modal-search-wrapper input-wrapper">
            <input
                id="exercise-search-input"
                type="text"
                name="exercise_name"
                className="modal-input"
                placeholder="Sök motion eller favoritpass..."
                value={form.exercise_name}
                onChange={handleChange}
                disabled={isLocked}
                autoComplete="off"
            />

            <img id="search-icon" src="/assets/images/diary-icons/search.svg" alt="" />

            {!isLocked && form.exercise_name && (
                <button className="reset-search-btn" onClick={clearSearch} type="button">
                    <img src="/assets/images/diary-icons/times-pink-larger.svg" alt="" />
                </button>
            )}

            {showSuggestions && filteredResults.length > 0 && (
                <div className="exercise-suggestions modal-search-results">
                    {/* STEPS */}
                    {stepResults.length > 0 && (
                        <div className="search-result-category">
                            <h4>Snabbval</h4>

                            {stepResults.map((result) => (
                                <div
                                    key="steps"
                                    className="search-result-item"
                                    onClick={() => handleSelect(result)}
                                >
                                    <span className="item-name">{result.data.name}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* FAVORITE SESSIONS */}
                    {mode === 'add' && favoriteSessions.length > 0 && (
                        <div className="search-result-category">
                            <h4>Favoritpass</h4>

                            {favoriteSessions.map((result) => (
                                <div
                                    key={`fav-${result.data.id}`}
                                    className="search-result-item"
                                    onClick={() => handleSelect(result)}
                                >
                                    <span className="item-name">{result.data.name}</span>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* EXERCISE TYPES */}
                    {exerciseTypes.length > 0 && (
                        <div className="search-result-category">
                            <h4>Motion</h4>

                            {exerciseTypes.map((result) => (
                                <div
                                    key={`type-${result.data.id}`}
                                    className="search-result-item"
                                    onClick={() => handleSelect(result)}
                                >
                                    <span className="item-name">{result.data.name}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {showInvalidMessage && <span className="input-error-text">Välj ett alternativ från listan.</span>}
        </div>
    );
};

export default ExerciseTypeSearch;
